import { render } from "./ClientCajas.vue?vue&type=template&id=5288faea"
import script from "./ClientCajas.vue?vue&type=script&lang=js"
export * from "./ClientCajas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__